module.exports = __webpack_public_path__ + "media/img/naked-logo-7c969bc0a063017e11cfdd5662b42e7d.png";